import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { referralAPI } from '../services/api';
import { formatDisplayDate } from '../utils/dateFormat';
import './CornerstoneDetail.css';

const GENDER_LABEL = { M: 'Male', F: 'Female', U: 'Unknown' };

function Field({ label, value }) {
  return (
    <div className="cs-field">
      <span className="cs-field-label">{label}</span>
      <span className="cs-field-value">{value || ''}</span>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="cs-section">
      <div className="cs-section-header">{title}</div>
      <div className="cs-section-body">{children}</div>
    </div>
  );
}

function CornerstoneDetail() {
  const { referralId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    referralAPI.getCornerstoneDetail(referralId)
      .then((res) => setData(res.data?.data ?? null))
      .catch(() => setError('Failed to load data'))
      .finally(() => setLoading(false));
  }, [referralId]);

  if (loading) return <div className="cs-page"><p className="cs-status">Loading…</p></div>;
  if (error) return <div className="cs-page"><p className="cs-status cs-error">{error}</p></div>;
  if (!data) return <div className="cs-page"><p className="cs-status">Not found.</p></div>;

  const insuranceDisplay = [data.insurance_company_name, data.insurance_type_description]
    .filter(Boolean).join(' / ') || '';

  const contactName = [data.contact_first_name, data.contact_last_name].filter(Boolean).join(' ');

  return (
    <div className="cs-page">
      <div className="cs-title">InComplete Clients Data Entry to Cornerstone</div>
      <div className="cs-client-name">
        {data.last_name}, {data.first_name}
      </div>

      <Section title="PA03">
        <Field label="Client Last, First Name" value={`${data.last_name || ''}, ${data.first_name || ''}`} />
        <Field label="Birthdate" value={data.date_of_birth ? formatDisplayDate(data.date_of_birth) : ''} />
        <Field label="Sex" value={GENDER_LABEL[data.gender] || data.gender || ''} />
        <Field label="Household Size" value={data.household_size != null ? String(data.household_size) : ''} />
        <Field label="Insurance" value={insuranceDisplay} />
        <Field label="Hispanic" value={data.hispanic === true ? 'Yes' : data.hispanic === false ? 'No' : ''} />
        <Field label="RACE" value={data.race_description || ''} />
        <Field label="PriLang" value={data.primary_language_description || ''} />
      </Section>

      <Section title="PA03 F9 Address">
        <Field label="Address" value={data.address_street_1 || ''} />
        <Field label="City" value={data.address_city || ''} />
        <Field
          label="State, Zip"
          value={[data.address_state, data.address_zip].filter(Boolean).join('  ')}
        />
        <Field label="County" value={data.county_name || ''} />
        <Field label="Home Phone" value={data.phone || ''} />
        <Field label="Email" value={data.email || ''} />
        <Field label="Primary Contact" value={contactName} />
        <Field label="Relationship" value={data.referral_relationship_description || ''} />
      </Section>

      <Section title="AS01">
        <Field label="RefReason" value={data.referral_reason || ''} />
        <Field label="Level1 Referral" value={data.referral_level_1_description || ''} />
        <Field label="Level2 Referral" value={data.referral_level_2_description || ''} />
        <Field label="Physician Name" value={data.physician_name || ''} />
        <Field label="Ref SC comment" value={data.referral_sc_comment || ''} />
      </Section>
    </div>
  );
}

export default CornerstoneDetail;
